<!-- attendanceEnabled is checked first so the async pipe is never reached while the feature is
     off: nothing renders, and the one-second elapsed timer is never subscribed to. -->
<ng-container *ngIf="attendanceEnabled && (vm$ | async) as vm">
  <button
    *ngIf="!vm.checkedIn"
    type="button"
    class="ac-chip ac-out"
    matTooltip="Check in for the day"
    aria-label="Check in"
    [disabled]="saving"
    (click)="checkIn(); $event.stopPropagation()">
    <mat-icon class="ac-icon">login</mat-icon>
    <span class="ac-text">Check in</span>
  </button>

  <button
    *ngIf="vm.checkedIn"
    type="button"
    class="ac-chip ac-in"
    [matTooltip]="'Checked in at ' + vm.sinceLabel + ' — click to check out'"
    aria-label="Check out"
    [disabled]="saving"
    (click)="checkOut(); $event.stopPropagation()">
    <span class="ac-dot" aria-hidden="true"></span>
    <span class="ac-time">{{ vm.elapsedLabel }}</span>
    <mat-icon class="ac-icon ac-logout">logout</mat-icon>
  </button>
</ng-container>
